import { render, staticRenderFns } from "./AddSanctionData.vue?vue&type=template&id=7643ef48"
import script from "./AddSanctionData.vue?vue&type=script&lang=js"
export * from "./AddSanctionData.vue?vue&type=script&lang=js"
import style0 from "./AddSanctionData.vue?vue&type=style&index=0&id=7643ef48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports